'use strict';

angular.module('pulse')
    .controller('ErrorCtrl',
    ['$scope', '$log', '$modalInstance', '$window', '$interval', '$location', '$rootScope', '$state', 'error', 'AuthenticationService', '$sce', 'HelperSvc',
        function ($scope, $log, $modalInstance, $window, $interval, $location, $rootScope, $state, error, AuthenticationService, $sce, HelperSvc) {

            $log.log('Error Controller');

            $scope.error = error;
            $scope.error.message = '';
            $scope.error.solution = 'If problem persists contact your administrator.';
            //$scope.error.redirect= true;
            $scope.error.closed = false;
            $scope.error.buttonText = 'OK';

            // check if user has access to the current app
            const isUseHasAppAccess = HelperSvc.checkAppAccess();
            

            //Add other special cases here.
            switch($scope.error.status) {
                case 403:
                    $scope.error.message = $sce.trustAsHtml(
                        `You don’t have permission to view this. You can tap to ${isUseHasAppAccess ? '<a data-redirect="root">reload this app,</a> or ' : ''}  <a data-redirect="logout">end your session.</a>`
                    );
                    $scope.error.solution = 'If you think you should be authorized, please contact PULSE Support.';
                    $scope.error.redirect = false;
                    $scope.error.buttonText = 'RETURN TO DASHBOARD';
                    break;
                case 404:
                    $scope.error.message = $sce.trustAsHtml(
                        `The information you requested does not exist. You can tap to ${isUseHasAppAccess ? '<a data-redirect="root">reload this app</a>, ' : ''} or <a data-redirect="logout">end your session.</a>`
                      );
                    $scope.error.solution = 'If you think you should be authorized, please contact PULSE Support.';
                    $scope.error.redirect = false;
                    $scope.error.buttonText = 'RETURN TO DASHBOARD';
                    break;
                default:
            }

            //This is currently not being used for anything
            //TODO: we might come back and make error handling a little more dynamic
            if($scope.error.redirect) {

                $scope.error.timer = 15;
                var interval = $interval(function() {

                    //If we already went somewhere else -- end the interval
                    if($scope.error.closed) {
                        $interval.cancel(interval);
                        return false;
                    }

                    //Times up -- clean yourself up and redirect
                    if($scope.error.timer === 0 && !$scope.error.closed) {
                        $interval.cancel(interval);
                        $scope.error.closed = true;
                        $modalInstance.close();
                        $log.log($state);
                        //$window.history.back();
                    }

                    if( $scope.error.timer>0) {
                        $scope.error.timer = $scope.error.timer - 1;
                    }

                }, 1000);

            }

            $scope.error.ok = function() {
                $log.log($window.location);
                //we need to clear out the local storage states to make sure we dont get stuck in a loop
                //TODO: maybe put a count into localstorage for how many times they click ok -- if more then 2 send them to dashboard.
                $rootScope.nocache = true;
                localStorage.removeItem('previousAttemptURL'); // Remove any kind of deep link that the user might have tried
                localStorage.removeItem(error.app+'toState'); // We want to remove state
                localStorage.removeItem(error.app+'toParams'); // We also want to remove specific app params

                if ($scope.error.status === 403 || $scope.error.status === 404) {
                    $window.location = $window.location.protocol + '//' + $window.location.hostname + '/dashboard';
                } else {
                    $window.location = $window.location.protocol + '//' + $window.location.hostname + $window.location.pathname;
                }
            };

            //$scope.back = function() {
            //    $modalInstance.close();
            //};

            $scope.refresh = function() {
                $window.location.reload();
            };

            var stateChange = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                $log.info('Error Controller State Change');
                if(!$scope.error.closed) {
                    $scope.error.closed = true;
                    $modalInstance.close();
                }
            });

          // use timeout to wait for DOM to update
           setTimeout(function() {
            $("#error-body a").click(function(event) {
                
                const redirectType = $(event.target).data('redirect');

                if (redirectType === 'root') {
                    $window.location = $window.location.protocol + '//' + $window.location.hostname + $window.location.pathname;
                } else if (redirectType === 'logout') {
                    AuthenticationService.logout();
                } else {
                    $log.log('no redirect from error modal');
                }

            });
           }, 600);

            //Destroy the function on search
            $scope.$on('$destroy', stateChange);
            $rootScope.modalInstance = $modalInstance;

        }]);
